const globals = {
  svg: {
    lineWidth: 3,
    jointRadius: 6,
    capWidth: 3,
    capHeight: 25,
    lineColor: '#FFFFFF',
    highlightColor: '#156EAC',
    borderThickness: 2,
    borderColor: '#000000',
    jointInsertDelay: 8, // number of pixels the mouse has to move from the last inserted point to show the joint
    areaOpacity: 0.6
  },
  zoom: {
    min: -5,
    max: 5,
    default: 0,
    mouseStep: 0.25,
    sliderStep: 0.125
  }
};

export default globals;